import categories from '@/store/categories';
import { sv } from 'vuetify/locale';

export default {
  welcome: 'Välkommen tillbaka',
  accounts: 'Konton',
  account: 'Konto',
  dashboard: "kontrollpanelen",
  loading: 'Laddar...',
  products: "Produkter",
  suppliers: "Leverantörer",
  customers: "Kunder",
  users: "Användare",
  product: "Produkt",
  productStatus: "Produktstatus",
  newProduct: "Ny produkt",
  errorCreateProduct: "Fel vid skapande av produkt, kontrollera alla fält igen.",
  errorUpdateProduct: "Fel vid uppdatering av produkt, kontrollera alla fält igen.",
  errorDeleteProduct: "Fel vid borttagning av produkt.",
  editProduct: "Redigera produkt",
  deleteProduct: "Ta bort produkt",
  productCreated: "Produkt skapad",
  productUpdated: "Produkt uppdaterad",
  productDeleted: "Produkt borttagen",
  editLocation: "Redigera plats",
  deleteLocation: "Ta bort plats",
  newLocation: "Ny plats",
  movementFrom: "Flytt från",
  cancel: "Avbryt",
  move: "Flytta",
  currentStock: "Nuvarande lager",
  stockRegulations: "Lagerregleringar",
  quantityToMove: "Antal att flytta",
  errorCreateLocation: "Fel vid skapande av plats, kontrollera alla fält igen.",
  errorUpdateLocation: "Fel vid uppdatering av plats, kontrollera alla fält igen.",
  errorDeleteLocation: "Fel vid borttagning av plats.",
  locationCreated: "Plats skapad",
  locationUpdated: "Plats uppdaterad",
  locationDeleted: "Plats borttagen",
  missingLocation: "Saknad plats",
  newSupplier: "Ny leverantör",
  regulationQuantity: "Reglera mängd",
  addSubtract: "Lägg till / Subtrahera",
  editSupplier: "Redigera leverantör",
  deleteSupplier: "Ta bort leverantör",
  newSupplier: "Ny leverantör",
  errorCreateSupplier: "Fel vid skapande av leverantör, kontrollera alla fält igen.",
  errorUpdateSupplier: "Fel vid uppdatering av leverantör, kontrollera alla fält igen.",
  errorDeleteSupplier: "Fel vid borttagning av leverantör.",
  supplierCreated: "Leverantör skapad",
  supplierUpdated: "Leverantör uppdaterad",
  supplierDeleted: "Leverantör borttagen",
  newCustomer: "Ny kund",
  editCustomer: "Redigera kund",
  deleteCustomer: "Ta bort kund",
  errorCreateCustomer: "Fel vid skapande av kund, kontrollera alla fält igen.",
  errorUpdateCustomer: "Fel vid uppdatering av kund, kontrollera alla fält igen.",
  errorDeleteCustomer: "Fel vid borttagning av kund.",
  regulationsSuccess: "Reglering lyckades",
  regulationsError: "Reglering misslyckades, kontrollera alla fält igen.",
  restock: "Fyll på lager",
  customerCreated: "Kund skapad",
  customerUpdated: "Kund uppdaterad",
  customerDeleted: "Kund borttagen",
  companyNumber: "Organisationsnummer",
  companyName: "Företagsnamn",
  address1: "Adress 1",
  address2: "Adress 2",
  city: "Stad",
  zipCode: "Postnummer",
  country: "Land",
  contactPhone: "Kontakttelefon",
  contactEmail: "Kontakt e-post",
  contactPerson: "Kontaktperson",
  supplier: "Leverantör",
  customer: "Kund",
  purchases: "Köp",
  purchase: "Köp",
  sales: "Försäljning",
  sale: "Försäljning",
  user: "Användare",
  about: "Om Capture IT",
  orders: "Beställningar",
  inventory: "Lager",
  reports: "Rapporter",
  priceValue: "Lager värde",
  stockValue: "Lager värde",
  regulations: "Lager regleringar",
  stockMovements: "Lagerförflyttningar",
  checkingDrafts: "Lager optælling",
  locations: "Platser",
  location: 'Plats',
  locationNumber: 'Platsnummer',
  defaultLocation: 'Standard plats',
  supplier: 'Leverantör',
  number: 'Nummer',
  name: 'Namn',
  locationName: 'Platsnamn',
  mandatoryDefaultLocation: '*Standard plats',
  selectRemoveAll: 'Välj / Ta bort alla',
  accountNumber: 'Kontonummer',
  fullname: 'Fullständigt namn',
  email: 'E-post',
  role: 'Roll',
  actions: 'Åtgärder',
  general: 'Allmän',
  other: 'Annat',
  image: 'Bild',
  productImage: 'Produktbild',
  barcode: 'Streckkod',
  quantity: 'Antal',
  labelQuantity: 'Antal etiketter',
  price: 'Pris',
  pricePerUnit: 'Pris per enhet',
  salesPrice: 'Försäljningspris',
  purchasePrice: 'Kostspris',
  total: 'Total',
  productName: 'Produktnamn',
  mandatoryProductName: '*Produktnamn',
  productNumber: 'Produktnummer',
  mandatoryProductNumber: '*Produktnummer',
  productGroup: 'Produktgrupp',
  stock: 'Lager',
  minStock: 'Minimi lager',
  status: 'Status',
  published: 'Publicerad',
  scheduled: 'Schemalagd',
  inactive: 'Inaktiv',
  date: 'Datum',
  description: 'Beskrivning',
  height: 'Höjd',
  width: 'Bredd',
  depth: 'Djup',
  weight: 'Vikt',
  quantity: 'Antal',
  usersPerPageText: 'Användare per sida:',
  productsPerPageText: 'Produkter per sida:',
  locationsPerPageText: 'Platser per sida:',
  suppliersPerPageText: 'Leverantörer per sida:',
  customersPerPageText: 'Kunder per sida:',
  purchasesPerPageText: 'Köp per sida:',
  salesPerPageText: 'Försäljning per sida:',
  ordersPerPageText: 'Beställningar per sida:',
  itemsPerPageText: 'Objekt per sida:',
  of: 'av',
  to: 'till',
  on: 'på',
  quantity: 'Antal',
  one: 'en',
  note: 'Anteckning',
  pageText: '{0}-{1} av {2}',
  fullnameMandatory: 'Fullständigt namn är obligatoriskt',
  emailInvalid: 'Ogiltig e-postadress',
  userMandatory: 'Användarnamn och lösenord är obligatoriska',
  emailMandatory: 'E-post är obligatorisk',
  userCreated: 'Användare skapad!',
  errorCreateUser: 'Fel vid skapande av användare, kontrollera alla fält igen.',
  userdeleted: 'Användaren har tagits bort',
  errorDeleteUser: 'Fel vid borttagning av användare',
  appname: 'PicklyWMS',
  login: 'Logga in',
  settings: 'Inställningar',
  importExport: 'Importera / Exportera',
  import: 'Importera',
  export: 'Exportera',
  importProducts: 'Importera produkter',
  exportProducts: 'Exportera produkter',
  uploadFile: 'Ladda upp fil',
  uploadFileText: 'Träk en Excel- eller CSV-fil här.',
  uploadSucceded: 'Uppladdning lyckades',
  uploadFailed: 'Uppladdning misslyckades',
  language: 'Språk',
  darkMode: 'Mørk modus',
  showProducts: 'Visa inaktiva produkter',
  showLocations: 'Visa inaktiva platser',
  other: 'Annat',
  update: 'Uppdatera',
  selectLanguage: 'Välj språk',
  english: 'Engelska',
  danish: 'Danska',
  swedish: 'Svenska',
  norwegian: 'Norsk',
  finnish: 'Finska',
  enabled: 'Aktiverad',
  disabled: 'Inaktiverad',
  required: 'Obligatorisk',
  optional: 'Valfritt',
  username: 'Användarnamn',
  password: 'Lösenord',
  print: 'Skriv ut',
  printSelected: 'Skriv ut valda',
  close: 'Stäng',
  save: 'Spara',
  cancel: 'Avbryt',
  reset: 'Återställ',
  clear: 'Rensa',
  create: 'Skapa',
  edit: 'Redigera',
  delete: 'Ta bort',
  confirmDelete: 'Bekräfta borttagning',
  deleteWarningUser: 'Är du säker på att du vill ta bort denna användare?',
  deleteWarningProduct: 'Är du säker på att du vill ta bort denna produkt?',
  error: 'Fel',
  success: 'Framgång',
  info: 'Info',
  warning: 'Varning',
  submit: 'Skicka',
  search: 'Sök',
  newUser: 'Ny användare',
  editUser: 'Redigera användare',
  deleteUser: 'Ta bort användare',
  oneRegistered: 'Det finns en registrerad',
  thereAreXRegistered: 'Det finns registrerade',
  weHaveOneRegistered: 'Vi har registrerat en',
  weHaveXRegistered: 'Vi har registrerat',
  warehouseManagement: 'Lagerhantering',
  trade: 'Handel',
  notYetImplemented: 'Inte implementerad än',
  notYetImplementedText: 'Denna funktion är inte implementerad än. Vi arbetar på det och hoppas kunna lansera den snart.',
  goBack: 'Gå tillbaka',
  contactSupport: 'Kontakta supporten om du behöver hjälp.',
  categories: 'Kategorier',
  category: 'Kategori',
  newCategory: 'Ny kategori',
  editCategory: 'Redigera kategori',
  deleteCategory: 'Ta bort kategori',
  categoryCreated: 'Kategori skapad',
  categoryUpdated: 'Kategori uppdaterad',
  categoryDeleted: 'Kategori borttagen',
  errorCreateCategory: 'Fel vid skapande av kategori, kontrollera alla fält igen.',
  errorUpdateCategory: 'Fel vid uppdatering av kategori, kontrollera alla fält igen.',
  errorDeleteCategory: 'Fel vid borttagning av kategori.',
  mandaatoryCategoryName: '*Kategorinamn',
  categoryName: 'Kategorinamn',
  categoryDescription: 'Kategoribeskrivning',
  categoriesPerPageText: 'Kategorier per sida:',
  usePrintServer: "Använd utskriftsserver (tyst utskrift)",
  printJobSent: "Utskriftsjobb skickat till servern.",
  printJobsSent: "Alla utskriftsjobb skickade till servern.",
  printJobFailed: "Utskriftsjobb misslyckades",
  printServerConnectionError: "Kunde inte ansluta till utskriftsservern. Kör den?",
  printBatchFailed: "Utskriftsbatch misslyckades. Minst ett jobb kunde inte skickas.",
  noLabelSelectedError: "Ingen etikettmall vald.",
  onlyInStock: "Endast produkter i lager",
  valueFromCostPrice: "Värde baserat på kostpris",
  columns: 'Kolumner',
  resetColumns: 'Återställ',
  showAll: 'Visa alla',
  sku: 'SKU',
  vat: 'Moms',
  supplierSku: 'Leverantörs-SKU',
  customField1: 'Anpassat fält 1',
  customField2: 'Anpassat fält 2',
  customField3: 'Anpassat fält 3',
  countryOfOrigin: 'Ursprungsland',
  tariffCode: 'Tulltaxenummer'
};